module.exports = __webpack_public_path__ + "static/media/aeronave.09da9018.png";